import { useTranslation } from 'react-i18next'

import { z } from '@/lib/zod'

export function NewUserPasswordSchema() {
  const { t } = useTranslation('common')

  return z.object({
    newPassword: z.string().min(1, t('validations.required')),
  })
}

export function ExistingUserPasswordSchema() {
  const { t } = useTranslation('common')

  return z.object({
    applicationPassword: z.string().min(1, t('validations.required')),
    serviceSolutionsPassword: z.string().min(1, t('validations.required')),
  })
}

export type NewUserPasswordForm = z.infer<
  ReturnType<typeof NewUserPasswordSchema>
>
export type ExistingUserPasswordForm = z.infer<
  ReturnType<typeof ExistingUserPasswordSchema>
>
